import { ColumnDef } from "@tanstack/react-table";

import { Employee } from "./schema";
import { DataTableRowActions } from "./data-table-row-actions";
import { DataTableColumnHeader } from "./data-table-column-header";
// import { Badge } from "@/components/ui/badge/badge";
import { Link } from "react-router-dom";
// import { cn } from "@/lib/utils";
import { EmployeeMarking } from "./comps/Emp-Marking";
import { Badge } from "@/components/ui/badge/badge";
import { cn } from "@/lib/utils";

export const columns: ColumnDef<Employee, any>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => <div className="w-[80px]">{row.index + 1}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => (
      <div>
        <Link
          to={`/admin/all-employees/${row.original.id}`}
          className="hover:underline"
        >
          {row.getValue("name")}
        </Link>
      </div>
    ),
    enableColumnFilter: true,
  },
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: ({ row }) => <div>{row.getValue("email")}</div>,
  },
  {
    accessorKey: "phone",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Phone" />
    ),
    cell: ({ row }) => <div>{row.getValue("phone")}</div>,
  },
  {
    accessorKey: "blockedStatus",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => (
      <Badge
        className={cn(
          row.getValue("blockedStatus") === "blocked"
            ? "bg-red-400"
            : "bg-emerald-400"
        )}
      >
        {row.getValue("blockedStatus") === "blocked" ? "Blocked" : "Active"}
      </Badge>
    ),
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
  },
  {
    id: "Today_Marking",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Today's Marking" />
    ),
    cell: ({ row }) => <EmployeeMarking row={row} />,
  },

  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
